(function () {
"use strict";
/* Re-entry guard: a second evaluation of this asset (duplicate section,
   theme-editor re-inject) re-binds any new roots instead of throwing. */
if (window.__emrQuizLoaded) { if (typeof window.__emrQuizBoot === "function") window.__emrQuizBoot(); return; }
window.__emrQuizLoaded = true;

/* ===============================================================
   EVERYMAN DRIVING EXPERIENCES — Find Your Experience Quiz
   Real products, real prices, real URLs. May 2026.
=============================================================== */

/* --- Real CDN imagery --- */
const IMG = {
  /* Intro hero */
  hero:          "https://everymandrivingexperiences.co.uk/cdn/shop/files/1-JR5_0035.jpg",
  /* Tile images */
  tile_supercar: "https://everymandrivingexperiences.co.uk/cdn/shop/files/1-8-Cars-Supercar-Driving-Experience-Gold-Range-Everyman-Driving-Experiences-67205313003905.jpg",
  tile_race:     "https://everymandrivingexperiences.co.uk/cdn/shop/files/Ferrari-458-Challenge-GT3-Race-Car-Experience-Weekday-Everyman-Driving-Experiences-67298052342145.jpg",
  tile_junior:   "https://everymandrivingexperiences.co.uk/cdn/shop/collections/mclaren_kids_incar_835328bc-d3fd-4fe2-8747-4eec0a2a6134.png",
  tile_passenger:"https://everymandrivingexperiences.co.uk/cdn/shop/files/1-5-Cars-Supercar-High-Speed-Passenger-Ride-Gold-Range-Everyman-Driving-Experiences-67215512666497.jpg",
  /* Result hero images — match each package */
  gold_single:     "https://everymandrivingexperiences.co.uk/cdn/shop/files/1-8-Cars-Supercar-Driving-Experience-Gold-Range-Everyman-Driving-Experiences-67206473810305.jpg",
  platinum_single: "https://everymandrivingexperiences.co.uk/cdn/shop/files/1-5-Cars-Supercar-Driving-Experience-Platinum-Range-Everyman-Driving-Experiences-67206560743809.jpg",
  diamond_single:  "https://everymandrivingexperiences.co.uk/cdn/shop/files/Lam-AJ0_1964.jpg",
  gold_multi:      "https://everymandrivingexperiences.co.uk/cdn/shop/files/East-Midlands-Venue-Offer-3-Car-Blast-High-Speed-Ride-Anytime-Everyman-Driving-Experiences-66667817140609.jpg",
  platinum_multi:  "https://everymandrivingexperiences.co.uk/cdn/shop/files/1-5-Cars-Supercar-Driving-Experience-Platinum-Range-Everyman-Driving-Experiences-67206600360321.jpg",
  five_plus:       "https://everymandrivingexperiences.co.uk/cdn/shop/files/5-Car-Supercar-Driving-Experience-Everyman-Driving-Experiences-34002877612320.png",
  gt_race:         "https://everymandrivingexperiences.co.uk/cdn/shop/files/Ultimate-Race-Car-Half-Day-Experience-Everyman-Driving-Experiences-67277012402561.jpg",
  half_day_race:   "https://everymandrivingexperiences.co.uk/cdn/shop/files/Ultimate-Race-Car-Full-Day-Experience-Everyman-Driving-Experiences-65532979642753.jpg",
  full_day:        "https://everymandrivingexperiences.co.uk/cdn/shop/files/Ultimate-Race-Car-Full-Day-Experience-Everyman-Driving-Experiences-65532979642753.jpg",
  passenger_gold:  "https://everymandrivingexperiences.co.uk/cdn/shop/files/1-5-Cars-Supercar-High-Speed-Passenger-Ride-Gold-Range-Everyman-Driving-Experiences-67215512666497.jpg",
  junior_exp:      "https://everymandrivingexperiences.co.uk/cdn/shop/collections/mclaren_kids_incar_835328bc-d3fd-4fe2-8747-4eec0a2a6134.png",
  ariel_wild:      "https://everymandrivingexperiences.co.uk/cdn/shop/files/Untitleddesign_19.jpg",
};

/* --- QUIZ QUESTIONS ------------------------------------------- */
/*
  4 genuinely discriminating questions — each answer meaningfully
  changes the recommended product. No recycled options.
*/
const QUESTIONS = [
  {
    id: "who",
    eyebrow: "01 / Four questions",
    title: "Who's taking the wheel?",
    sub: "Your answer shapes everything — the car, the format, the price.",
    options: [
      {
        id: "me",
        label: "Me — I want to drive",
        hint: "You're behind the wheel. We'll match you to the right car, tier, and amount of track time.",
        tag: "Driver"
      },
      {
        id: "gift",
        label: "It's a gift for someone",
        hint: "eVoucher delivered within 2 hours. They choose their own car and date. Valid 12 months.",
        tag: "Gift / Voucher"
      },
      {
        id: "junior",
        label: "It's for my child or teenager",
        hint: "We have dedicated junior experiences across 23 venues. From age 10, no licence needed. They actually drive.",
        tag: "Junior · Ages 10+ · 23 venues"
      },
      {
        id: "passenger",
        label: "I'd rather ride shotgun — let a pro drive",
        hint: "All the adrenaline, zero responsibility. A professional driver shows you what these cars really do. Ages 5+.",
        tag: "Passenger ride"
      },
    ]
  },

  {
    id: "machine",
    eyebrow: "02 / The car",
    title: "What kind of car speaks to you?",
    sub: "Be honest. The right car makes the whole day.",
    options: [
      {
        id: "supercar",
        label: "A proper supercar — Ferrari, Lambo, Aston",
        hint: "Choose your badge from our Gold, Platinum, or Diamond fleet. 30+ iconic machines available.",
        tag: "Ferrari · Lamborghini · McLaren · Aston Martin · Porsche"
      },
      {
        id: "race",
        label: "A real race car — GT3, Formula, proper motorsport",
        hint: "Ferrari 458 GT3, Lamborghini Huracán GT3, McLaren 570s GT4, Audi R8 LMS GT3. Not road cars.",
        tag: "GT3 · GT4 · Race spec"
      },
      {
        id: "multiple",
        label: "As many different cars as possible",
        hint: "Multi-car packages let you mix tiers and models. Drive 3, 5, even 8 supercars in one session.",
        tag: "Multi-car packages · Up to 8 cars"
      },
      {
        id: "wild",
        label: "Something raw and unfiltered — Ariel Atom, Rage Buggy",
        hint: "No roof, no doors, no mercy. The Ariel Atom hits 0–60 in under 3 seconds. Not for the faint-hearted.",
        tag: "Ariel Atom · Extreme Rage Buggy"
      },
    ]
  },

  {
    id: "time",
    eyebrow: "03 / Track time",
    title: "How long do you want on track?",
    sub: "More time means more laps, more cars, more improvement.",
    options: [
      {
        id: "blast",
        label: "A quick blast — a couple of hours",
        hint: "Drive 1–2 cars, get the thrill, be home by lunch. Perfect first experience or a tight schedule.",
        tag: "2–3 hours · 1–2 cars"
      },
      {
        id: "half",
        label: "A proper session — half a day",
        hint: "Drive 3–5 cars with proper stints in each. Enough time to actually feel the difference.",
        tag: "Half day · 3–5 cars"
      },
      {
        id: "full",
        label: "All day — I want every last minute on track",
        hint: "Multiple sessions, multiple machines, full instructor coaching. This is the complete experience.",
        tag: "Full day · Maximum laps"
      },
      {
        id: "dontmind",
        label: "Whatever the experience includes — I'm flexible",
        hint: "We'll match you to the best format for your chosen car and budget.",
        tag: "Flexible"
      },
    ]
  },

  {
    id: "budget",
    eyebrow: "04 / Budget",
    title: "What's the budget per person?",
    sub: "Every tier is a proper experience. Pick the one that fits.",
    options: [
      {
        id: "under100",
        label: "Under £100",
        hint: "Gold supercar blasts from £59. Genuine Ferraris and Lamborghinis on real circuits.",
        tag: "Gold range · From £59"
      },
      {
        id: "100_200",
        label: "£100 – £200",
        hint: "Multi-car Gold packages, single Platinum supercars, GT Race Cars from £99.",
        tag: "Platinum · Multi-car · GT Race"
      },
      {
        id: "200_400",
        label: "£200 – £400",
        hint: "Multi-car Platinum, Diamond supercars, Race Car half-day packages.",
        tag: "Diamond · Multi-car Platinum · Half-day race"
      },
      {
        id: "400plus",
        label: "£400+ — money's not the point",
        hint: "Full day race programmes, five-plus Diamond supercars, premium venues.",
        tag: "Full day · Diamond multi-car · Ultimate"
      },
    ]
  },
];

/* --- REAL PRODUCTS -------------------------------------------- */
const PACKAGES = {

  gold_single: {
    id: "gold_single",
    name: "Gold Supercar Blast",
    tagline: "Pick your icon. Drive it properly.",
    price: "£59",
    from: true,
    duration: "2–3 hours",
    cars: "Ferrari 430, Lamborghini Gallardo, Aston Martin DB9, Audi R8 V8, Nissan GTR, BMW i8 & more",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/gold-range-supercar-driving-experience-1-8-car",
    blurb: "One supercar, your choice of badge, at a venue like Dunsfold or Brands Hatch. The Gold fleet covers all the icons — Ferrari, Lamborghini, Aston Martin, Audi R8 and more. Three miles of track time with a personal instructor from the first lap. No experience needed.",
    includes: [
      "One Gold-tier supercar — you choose the badge",
      "3-mile circuit blast with a personal instructor",
      "High-speed passenger ride included",
      "eVoucher in 2 hours · valid 12 months",
    ],
  },

  platinum_single: {
    id: "platinum_single",
    name: "Platinum Supercar Blast",
    tagline: "Ferrari 458. McLaren 570s. Lamborghini Huracán. A league above.",
    price: "£89",
    from: true,
    duration: "2–3 hours",
    cars: "Ferrari 458 Italia, McLaren 570s, Lamborghini Huracán LP-610, Audi R8 V10, Aston Martin DB11, Nissan GTR Gen3",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/1-8-cars-supercar-driving-experience-platinum-range",
    blurb: "The Platinum fleet is where the cars get serious. More power, more presence, more technology under your hands. One car chosen by you — driven with one-to-one instructor coaching at Dunsfold, Brands Hatch, or one of 22+ venues.",
    includes: [
      "One Platinum-tier supercar — Ferrari 458, McLaren 570s, Lamborghini Huracán & more",
      "3-mile circuit blast with personal instructor",
      "High-speed passenger ride included",
      "eVoucher in 2 hours · valid 12 months",
    ],
  },

  diamond_single: {
    id: "diamond_single",
    name: "Diamond Supercar Experience",
    tagline: "Ferrari 488. Lamborghini Aventador. F1 Safety Cars. This is the top tier.",
    price: "£99",
    from: true,
    duration: "2–3 hours",
    cars: "Ferrari 488, Lamborghini Aventador LP700, Porsche GT3 RS, Mercedes AMG GTR F1 Safety Car, Aston Martin AM-V8 F1 Safety Car",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/1-4-cars-supercar-driving-experience-diamond-range",
    blurb: "The Diamond fleet is the pinnacle of what we run. Cars worth more than most people's houses, driven by you at Dunsfold, Brands Hatch, or your choice of 22+ venues. Ferrari 488, Lamborghini Aventador, the F1 Safety Cars — one-to-one instruction throughout.",
    includes: [
      "One Diamond-tier supercar — Ferrari 488, Aventador, Porsche GT3 RS & more",
      "3-mile circuit blast with dedicated instructor",
      "Includes the F1 Safety Car experiences",
      "eVoucher in 2 hours · valid 12 months",
    ],
  },

  gold_multi: {
    id: "gold_multi",
    name: "Multi-Car Gold Package",
    tagline: "Three different supercars. Three completely different feelings.",
    price: "£129",
    from: true,
    duration: "Half day",
    cars: "3 Gold-tier supercars — you choose the badges",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/gold-range-supercar-driving-experience-1-8-car",
    blurb: "Our most-booked format. Three supercars, each with its own character — drive them back-to-back and feel the difference between a Ferrari F430, a Lamborghini Gallardo, and an Aston Martin DB9. Your instructor stays with you throughout.",
    includes: [
      "Three Gold-tier supercars — you pick the badges",
      "3 miles in each car with a personal instructor",
      "High-speed passenger ride included",
      "Scale up to 8 cars on the same booking",
    ],
  },

  platinum_multi: {
    id: "platinum_multi",
    name: "Multi-Car Platinum Package",
    tagline: "Three premium machines. More power, more comparison, more memorable.",
    price: "£189",
    from: true,
    duration: "Half day",
    cars: "3 Platinum-tier supercars — Ferrari 458, McLaren 570s, Lamborghini Huracán & more",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/1-8-cars-supercar-driving-experience-platinum-range",
    blurb: "Three cars from the Platinum fleet in a single session — enough time in each to actually get comfortable, compare character, and start developing real technique. The step up from Gold that most drivers immediately notice.",
    includes: [
      "Three Platinum-tier supercars — you choose",
      "3 miles in each car with dedicated instructor",
      "High-speed passenger ride included",
      "Upgrade to 5 cars from £249",
    ],
  },

  five_plus: {
    id: "five_plus",
    name: "5-Car Supercar Package",
    tagline: "Five supercars in one session. Pick your tier — or mix them.",
    price: "£179",
    from: true,
    duration: "Half day",
    cars: "5 supercars — Gold, Platinum, or Diamond. Upgradeable to 8 cars.",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/5-supercar-driving-experience",
    blurb: "Can't pick just one? Drive five. Choose from Gold (from £179), Platinum (from £249), or Diamond (from £309) — or mix across tiers. The biggest single variety session we offer, scalable up to 8 cars.",
    includes: [
      "Five supercars — Gold, Platinum, or Diamond tier",
      "3 miles in each car with instructor",
      "Upgrade to 6, 7, or 8 cars available",
      "High-speed passenger ride included",
    ],
  },

  gt_race: {
    id: "gt_race",
    name: "GT Race Car Experience",
    tagline: "This isn't a supercar. This is a proper racing machine.",
    price: "£99",
    from: true,
    duration: "2–3 hours",
    cars: "Ferrari 458 GT3, Lamborghini Huracán GT3, McLaren 570s GT4, Audi R8 V10+ LMS GT3",
    venue: "Dunsfold, Brands Hatch & more",
    url: "https://everymandrivingexperiences.co.uk/products/gt-race-cars",
    blurb: "GT3 and GT4 race cars built for actual competition — not road cars with a stripe. No driver aids, mechanical feedback through every input, and a radio-linked instructor who expects you to improve. This is real motorsport, accessible.",
    includes: [
      "Choice of Ferrari 458 GT3, Lamborghini GT3, McLaren GT4, or Audi GT3",
      "Circuit blast with radio-linked instructor",
      "Race helmet and HANS device provided",
      "Mix multiple race cars for extended variety",
    ],
  },

  half_day_race: {
    id: "half_day_race",
    name: "Race Car Half Day",
    tagline: "Half a day in the fastest cars we run. No warm-up needed.",
    price: "£399",
    from: false,
    duration: "Half day",
    cars: "Multiple GT3/GT4 race cars — full programme",
    venue: "Dunsfold, Brands Hatch & more",
    url: "https://everymandrivingexperiences.co.uk/products/gt-race-cars",
    blurb: "Four hours on track across multiple GT race machines. Enough sessions to build real pace, enough cars to compare. Full instructor coaching, timed laps, and a debrief that tells you exactly what changed.",
    includes: [
      "Multiple GT3/GT4 race cars",
      "Extended half-day on-track sessions",
      "Full instructor coaching and lap debrief",
      "Race suit, helmet, and HANS device provided",
    ],
  },

  full_day: {
    id: "full_day",
    name: "Ultimate Race Car Full Day",
    tagline: "All day. All track. Every last lap.",
    price: "£849",
    from: false,
    duration: "Full day",
    cars: "Multiple GT3/GT4 race cars — complete programme",
    venue: "Dunsfold, Brands Hatch & more",
    url: "https://everymandrivingexperiences.co.uk/products/gt-race-cars",
    blurb: "A full day in real race cars on one of the UK's best circuits. Multiple machines, multiple sessions — enough laps to genuinely improve, enough variety to keep it extraordinary. The most immersive experience we run.",
    includes: [
      "Full day with multiple GT3/GT4 race cars",
      "Multiple sessions with professional coaching",
      "Race suit, helmet, and HANS device",
      "Timed laps and full instructor debrief",
    ],
  },

  passenger_gold: {
    id: "passenger_gold",
    name: "High Speed Passenger Ride",
    tagline: "All the adrenaline. None of the responsibility.",
    price: "£49",
    from: true,
    duration: "1–2 hours",
    cars: "Gold, Platinum, or Diamond supercar — passenger seat",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/1-8-cars-supercar-high-speed-ride-experience-gold-range",
    blurb: "Strap in, hold on, and let our professional drivers show you what these cars can actually do. Intense acceleration, late braking, fast cornering — from the best seat in the house. Suitable for ages 5 and up.",
    includes: [
      "Passenger ride in a Gold, Platinum, or Diamond supercar",
      "Professional Everyman driver at the wheel",
      "Full circuit and safety briefing",
      "Ages 5+ — perfect for families",
    ],
  },

  junior_exp: {
    id: "junior_exp",
    name: "Junior Driving Experience",
    tagline: "Their first time behind the wheel. Make it one to remember.",
    price: "£49",
    from: true,
    duration: "1–2 hours",
    cars: "Junior-spec supercars, rally cars, and more",
    venue: "23 venues including Dunsfold & Brands Hatch",
    url: "https://everymandrivingexperiences.co.uk/pages/junior-driving-experiences",
    blurb: "Dedicated junior driving experiences for ages 10 and up — no licence required, no experience needed. They drive a real car on a genuine circuit with a qualified instructor beside them. One of those days they will absolutely talk about forever.",
    includes: [
      "Real driving at Dunsfold, Brands Hatch & more",
      "Qualified instructor for every lap",
      "Ages 10+ — no licence required",
      "Junior supercar, rally car, and combination options",
    ],
  },

  ariel_wild: {
    id: "ariel_wild",
    name: "Ariel Atom Experience",
    tagline: "No roof. No doors. 0–60 in under 3 seconds. No mercy.",
    price: "£59",
    from: true,
    duration: "2–3 hours",
    cars: "Ariel Atom (Gold) · Ariel Atom Supercharged (Platinum) · Ariel Atom Cup",
    venue: "22+ UK venues — you choose",
    url: "https://everymandrivingexperiences.co.uk/products/ariel-atom-driving-experience-1",
    blurb: "The Ariel Atom is the wildest car in our fleet — no bodywork, a screaming engine inches from your head, and acceleration that rearranges your face. Available in Gold (standard Atom) or Platinum (Supercharged). Nothing else comes close.",
    includes: [
      "Ariel Atom — Gold standard or Platinum Supercharged",
      "Circuit blast with one-to-one instructor",
      "No roof, no doors — fully exposed driving",
      "Combine with other supercars for maximum variety",
    ],
  },

};

/* --- RECOMMENDATION ENGINE ------------------------------------ */
/*
  Priority rules — each answer combination directly maps to a product.
  No fuzzy scoring: answers are specific enough to drive hard logic.
*/
/* Returns true when the current answers already uniquely determine a result
   — no point asking further questions. */
function isDecisive(ans) {
  const { who, machine } = ans;
  if (who === "junior" || who === "passenger") return true;   // Q1 locks it
  if (machine === "wild") return true;                         // Q2 locks it
  return false;
}

function recommend(ans) {
  const { who, machine, time, budget } = ans;
  const build = (primary, alt) => ({
    primary: PACKAGES[primary],
    alternate: PACKAGES[alt],
    // Only include reasons for questions actually answered
    reasons: [
      who     ? { k: "Who",      v: label("who",     who)     } : null,
      machine ? { k: "Car type", v: label("machine", machine) } : null,
      time    ? { k: "Duration", v: label("time",    time)    } : null,
      budget  ? { k: "Budget",   v: label("budget",  budget)  } : null,
    ].filter(Boolean)
  });

  // -- Hard overrides by who --
  if (who === "junior")    return build("junior_exp",    "passenger_gold");
  if (who === "passenger") return build("passenger_gold","gold_single");

  // -- Wild car path --
  if (machine === "wild") return build("ariel_wild", "gt_race");

  // -- Race car path --
  if (machine === "race") {
    if (time === "full" || budget === "400plus") return build("full_day",       "half_day_race");
    if (budget === "200_400" || time === "half") return build("half_day_race",  "gt_race");
    return build("gt_race", "platinum_single");
  }

  // -- Maximum variety --
  if (machine === "multiple") {
    if (budget === "400plus" || time === "full")    return build("five_plus",      "platinum_multi");
    if (budget === "200_400")                        return build("platinum_multi", "five_plus");
    if (budget === "100_200" || time === "half")     return build("gold_multi",     "platinum_multi");
    return build("gold_multi", "gold_single");
  }

  // -- Single iconic supercar --
  // Gift buyer — prioritise good mid-range giftable options
  if (who === "gift") {
    if (budget === "400plus")  return build("five_plus",       "diamond_single");
    if (budget === "200_400")  return build("platinum_multi",  "diamond_single");
    if (budget === "100_200")  return build("gold_multi",      "platinum_single");
    return build("gold_single", "gold_multi");
  }

  // Self driver, single supercar
  if (machine === "supercar") {
    if (budget === "400plus") {
      if (time === "full") return build("five_plus",      "diamond_single");
      return build("diamond_single", "five_plus");
    }
    if (budget === "200_400") return build("diamond_single",   "platinum_multi");
    if (budget === "100_200") {
      if (time === "half") return build("gold_multi",       "platinum_single");
      return build("platinum_single", "gold_multi");
    }
    // under £100
    if (time === "half") return build("gold_multi",      "platinum_single");
    return build("gold_single", "platinum_single");
  }

  // Fallback
  return build("gold_single", "platinum_single");
}

function label(qid, oid) {
  const q = QUESTIONS.find(q => q.id === qid);
  return q?.options.find(o => o.id === oid)?.label || oid;
}

/* ===============================================================
   HARDENED RUNTIME  (everything below the data + engine above)
   - IIFE-scoped, re-entry safe, per-root instances
   - Shopify theme-editor section lifecycle aware
   - Keyboard + screen-reader accessible, reduced-motion aware
   - Null / bad-data / broken-image guards throughout
=============================================================== */

/* Founding year — SINGLE SOURCE OF TRUTH.
   ⚠️ VERIFY this is the true founding year before publishing; the
   "years running" figure is now derived from it so the two can
   never silently diverge year-on-year. */
var EMR_FOUNDED = 1980;
var EMR_YEARS = Math.max(1, new Date().getFullYear() - EMR_FOUNDED);

/* Motion preference (vestibular safety) */
var EMR_RM = (function () {
  try { return window.matchMedia("(prefers-reduced-motion: reduce)"); }
  catch (e) { return { matches: false }; }
})();

var FALLBACK_IMG = (typeof IMG === "object" && IMG && IMG.gold_single) || "";
var NEWTAB = '<span class="eq-sr-only"> (opens in a new tab)</span>';

/* ─── Helpers ─── */
function esc(s) {
  return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
  });
}
function mk(html) {
  var t = document.createElement("template");
  t.innerHTML = String(html).trim();
  return t.content.firstElementChild; /* may be null — callers guard */
}
/* Keep hero downloads small: ask the Shopify CDN to resize.
   Skips local / non-Shopify URLs and anything already parameterised. */
function sized(url, w) {
  if (!url || typeof url !== "string") return url || "";
  if (url.indexOf("/cdn/shop/") === -1) return url;
  if (url.indexOf("?") !== -1) return url;
  return url + "?width=" + w;
}
/* Broken image → try the fallback asset → then a solid brand panel. */
function bindImgFallback(scope) {
  if (!scope) return;
  var imgs = scope.querySelectorAll("img");
  for (var i = 0; i < imgs.length; i++) {
    imgs[i].addEventListener("error", function () {
      if (this.getAttribute("data-eq-fb") === "2") return;
      if (this.getAttribute("data-eq-fb") === "1") {
        this.setAttribute("data-eq-fb", "2");
        this.style.visibility = "hidden";
        if (this.parentElement) this.parentElement.style.background = "var(--green)";
        return;
      }
      this.setAttribute("data-eq-fb", "1");
      if (FALLBACK_IMG) this.src = FALLBACK_IMG; else this.dispatchEvent(new Event("error"));
    });
  }
}

/* ─── Per-root controller (no globals shared between instances) ─── */
function createQuiz(root) {
  var mount = root.querySelector("[data-eq-root]") || root.querySelector("#eqRoot") || root;
  if (!mount) return null;

  /* Per-instance config (Shopify section settings, injected as JSON).
     Standalone embeds have no config → everything falls back to defaults. */
  var cfg = {};
  try {
    var cfgEl = root.querySelector("[data-eq-config]");
    if (cfgEl && cfgEl.textContent && cfgEl.textContent.trim()) cfg = JSON.parse(cfgEl.textContent) || {};
  } catch (e) { cfg = {}; }
  var mode = String(root.getAttribute("data-eq-mode") || cfg.mode || "full").toLowerCase();
  var quizUrl = root.getAttribute("data-eq-url") || cfg.quizUrl || "/pages/find-your-experience";

  var uid = "eq-" + Math.random().toString(36).slice(2, 8);
  var state = { screen: "intro", idx: 0, answers: {}, result: null, locking: false, booted: false };

  /* Persistent SR live region — lives on root so mount re-renders don't wipe it */
  var live = document.createElement("div");
  live.className = "eq-sr-only";
  live.setAttribute("aria-live", "polite");
  live.setAttribute("role", "status");
  root.appendChild(live);
  function announce(msg) {
    live.textContent = "";
    window.setTimeout(function () { live.textContent = msg; }, 40);
  }

  function motionScroll() {
    try { root.scrollIntoView({ behavior: EMR_RM.matches ? "auto" : "smooth", block: "start" }); }
    catch (e) { try { root.scrollIntoView(); } catch (e2) {} }
  }
  function focusEl(el) {
    if (!el) return;
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }

  /* Drop answers for questions that come AFTER the given index, so a
     changed earlier answer can never leave stale reasons on the result. */
  function pruneAfter(idx) {
    for (var i = idx + 1; i < QUESTIONS.length; i++) {
      delete state.answers[QUESTIONS[i].id];
    }
  }

  function render() {
    state.locking = false;
    if (!mount) return;
    if (state.screen === "intro") renderIntro();
    else if (state.screen === "quiz") renderQuiz();
    else renderResult();
  }

  /* ═══════════ INTRO ═══════════ */
  function renderIntro() {
    mount.innerHTML = "";

    var stats = [
      [String(EMR_YEARS), "Years running"],
      ["22+", "UK venues"],
      ["100+", "Cars in fleet"],
      ["★ 9yr", "TripAdvisor award"],
      ["60-day", "Refund policy"]
    ];

    /* Optional per-instance overrides (Shopify section settings) */
    var heroImg = (cfg.heroImage && String(cfg.heroImage)) || IMG.hero;
    var headingHTML = (cfg.heading && String(cfg.heading).trim())
      ? esc(cfg.heading) : 'Find the drive<br/>made for <em>you.</em>';
    var subText = (cfg.subheading && String(cfg.subheading).trim())
      ? esc(cfg.subheading)
      : "Answer four quick questions and we'll match you to the right experience from our full range — with real cars, real prices, and a clear reason why.";
    var ctaLabel = (cfg.ctaLabel && String(cfg.ctaLabel).trim()) ? esc(cfg.ctaLabel) : "Start the quiz";
    var showStats = cfg.showStats !== false;

    /* In hero mode the CTA links to the dedicated quiz page; in full mode it
       starts the inline quiz. Same look, different element. */
    var startCtl = (mode === "hero")
      ? '<a href="' + esc(quizUrl) + '" class="eq-btn eq-btn-white eq-start">' + ctaLabel + ' <span class="eq-arr" aria-hidden="true">→</span></a>'
      : '<button class="eq-btn eq-btn-white eq-start" type="button">' + ctaLabel + ' <span class="eq-arr" aria-hidden="true">→</span></button>';

    var hero = mk(
      '<div class="eq-hero eq-fade">' +
        '<div class="eq-hero-img-col">' +
          '<img src="' + esc(sized(heroImg, 1600)) + '" alt="Everyman Driving Experiences — supercars on track" />' +
        '</div>' +
        '<div class="eq-hero-text-col">' +
          '<div class="eq-hero-eyebrow"><span class="bar" aria-hidden="true"></span>Everyman Driving Experiences · Est. ' + EMR_FOUNDED + '</div>' +
          '<h1 class="eq-hero-h1" id="' + uid + '-h1">' + headingHTML + '</h1>' +
          '<p class="eq-hero-sub">' + subText + '</p>' +
          '<div style="display:flex;align-items:center;gap:14px;flex-wrap:wrap">' +
            startCtl +
            '<a href="https://everymandrivingexperiences.co.uk/collections/all" class="eq-btn eq-btn-ghost-green" target="_blank" rel="noopener">Browse all experiences' + NEWTAB + '</a>' +
          '</div>' +
          '<p class="eq-hero-meta">~60 seconds · no email required · 268 experiences available</p>' +
        '</div>' +
      '</div>'
    );

    var strip = showStats ? mk(
      '<div class="eq-strip"><div class="eq-shell"><div class="eq-strip-inner">' +
        stats.map(function (s) {
          return '<div class="eq-strip-item"><span class="eq-strip-n">' + esc(s[0]) +
                 '</span><span class="eq-strip-l">' + esc(s[1]) + '</span></div>';
        }).join("") +
      '</div></div></div>'
    ) : null;

    if (hero) mount.appendChild(hero);
    if (strip) mount.appendChild(strip);
    bindImgFallback(mount);

    /* Hero mode: the CTA is a real link — let the browser navigate, bind nothing. */
    if (mode === "hero") return;

    var startBtn = mount.querySelector(".eq-start");
    if (startBtn) {
      startBtn.addEventListener("click", function () {
        state.booted = true;
        state.screen = "quiz";
        state.idx = 0;
        render();
        motionScroll();
      });
      if (state.booted) focusEl(startBtn); /* only after a user round-trip, never on first load */
    }
  }

  /* ═══════════ QUIZ ═══════════ */
  function renderQuiz() {
    var q = QUESTIONS[state.idx];
    /* Guard: index ever out of range → decide now instead of throwing. */
    if (!q) {
      state.result = recommend(state.answers);
      state.screen = "result";
      return render();
    }
    var total = QUESTIONS.length;
    mount.innerHTML = "";

    var section = mk(
      '<div class="eq-quiz-section eq-fade">' +
        '<div class="eq-shell"><div class="eq-qwrap">' +
          '<div class="eq-qprompt">' +
            '<div class="eq-qeyebrow"><span class="bar" aria-hidden="true"></span>' + esc(q.eyebrow) + '</div>' +
            '<h2 class="eq-qh" id="' + uid + '-qh">' + esc(q.title) + '</h2>' +
            '<p class="eq-qsub">' + esc(q.sub) + '</p>' +
            '<div class="eq-qnav">' +
              '<button type="button" class="eq-btn eq-btn-ghost eq-back"' + (state.idx === 0 ? " disabled" : "") + '>' +
                '<span class="eq-arr" aria-hidden="true" style="transform:scaleX(-1);display:inline-block">→</span> Back' +
              '</button>' +
              '<div class="eq-rail" aria-hidden="true"></div>' +
            '</div>' +
          '</div>' +
          '<div class="eq-qoptions eq-opts" role="group" aria-labelledby="' + uid + '-qh"></div>' +
        '</div></div>' +
      '</div>'
    );
    if (!section) return;
    mount.appendChild(section);

    /* Progress rail (decorative; state announced to SR via live region) */
    var rail = section.querySelector(".eq-rail");
    for (var i = 0; i < total; i++) {
      var seg = document.createElement("div");
      seg.className = "seg" + (i < state.idx ? " done" : "") + (i === state.idx ? " curr" : "");
      rail.appendChild(seg);
    }

    var optsEl = section.querySelector(".eq-opts");
    var isLastQ = state.idx === total - 1;

    q.options.forEach(function (opt, i) {
      var alreadySelected = state.answers[q.id] === opt.id;
      var btn = mk(
        '<button class="eq-opt' + (alreadySelected ? " selected" : "") + '" type="button"' +
          ' data-id="' + esc(opt.id) + '" aria-pressed="' + (alreadySelected ? "true" : "false") + '">' +
          '<div class="orow">' +
            '<span class="oidx" aria-hidden="true">0' + (i + 1) + '</span>' +
            '<span class="olbl">' + esc(opt.label) + '</span>' +
            '<span class="opip" aria-hidden="true"></span>' +
          '</div>' +
          (opt.hint ? '<div class="ohint">' + esc(opt.hint) + '</div>' : "") +
          (opt.tag ? '<div class="otag">' + esc(opt.tag) + '</div>' : "") +
        '</button>'
      );
      if (!btn) return;

      btn.addEventListener("click", function () {
        if (state.locking) return;          /* re-entry lock — blocks keyboard + mouse double-fire */
        state.locking = true;

        var all = optsEl.querySelectorAll(".eq-opt");
        for (var k = 0; k < all.length; k++) {
          all[k].classList.remove("selected", "selecting");
          all[k].setAttribute("aria-pressed", "false");
          all[k].disabled = true;           /* disabled blocks keyboard activation too */
        }
        btn.classList.add("selecting");
        btn.setAttribute("aria-pressed", "true");
        state.answers[q.id] = opt.id;
        pruneAfter(state.idx);              /* changing this answer invalidates later ones */

        window.setTimeout(function () {
          if (isLastQ || isDecisive(state.answers)) {
            state.result = recommend(state.answers);
            state.screen = "result";
          } else {
            state.idx++;
          }
          render();
          motionScroll();
        }, 320);
      });

      optsEl.appendChild(btn);
    });

    var backBtn = section.querySelector(".eq-back");
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        if (state.idx > 0) {
          state.idx--;
          pruneAfter(state.idx);            /* leaving a later question clears its (now-irrelevant) answers */
          render();
          motionScroll();
        }
      });
    }

    announce("Question " + (state.idx + 1) + " of " + total + ". " + q.title);

    /* Move keyboard focus to the chosen option, else the first — so keyboard
       users land inside the question and the group label is announced. */
    var target = optsEl.querySelector(".eq-opt.selected") || optsEl.querySelector(".eq-opt");
    if (state.booted) focusEl(target);
  }

  /* ═══════════ RESULT ═══════════ */
  function renderResult() {
    var r = state.result;
    if (!r || !r.primary) {                 /* guard: never render a broken result */
      state.screen = "intro";
      return renderIntro();
    }
    var primary = r.primary || PACKAGES.gold_single;
    var alternate = r.alternate || PACKAGES.platinum_single;
    var reasons = r.reasons || [];
    var img = sized(IMG[primary.id] || FALLBACK_IMG, 1600);
    var imgAlt = sized(IMG[alternate.id] || FALLBACK_IMG, 800);
    mount.innerHTML = "";

    var rows = [["Duration", primary.duration], ["Cars", primary.cars], ["Venues", primary.venue]];

    var section = mk(
      '<div class="eq-result-section eq-fade">' +
        '<div class="eq-shell"><div class="eq-res-topbar">' +
          '<span class="lbl">Your match</span><div class="rule" aria-hidden="true"></div>' +
          '<button type="button" class="eq-btn eq-btn-ghost eq-retake"><span class="eq-arr" aria-hidden="true">←</span> Retake quiz</button>' +
        '</div></div>' +

        '<div class="eq-res-hero">' +
          '<img src="' + esc(img) + '" alt="" aria-hidden="true" loading="eager" decoding="async" />' +
          '<div class="hero-overlay" aria-hidden="true"></div>' +
          '<div class="hero-text"><div class="eq-shell">' +
            '<div class="eq-res-eyebrow"><span class="bar" aria-hidden="true"></span>Recommended for you</div>' +
            '<h1 class="eq-res-name" id="' + uid + '-res"><em>' + esc(primary.name) + '</em></h1>' +
            '<p class="eq-res-tagline-hero">' + esc(primary.tagline) + '</p>' +
          '</div></div>' +
        '</div>' +

        '<div class="eq-shell">' +
          '<div class="eq-res-body">' +
            '<div>' +
              '<div class="eq-res-table">' +
                rows.map(function (kv) {
                  return '<div class="eq-res-row"><span class="rk">' + esc(kv[0]) +
                         '</span><span class="rv">' + esc(kv[1]) + '</span></div>';
                }).join("") +
              '</div>' +
              '<p class="eq-blurb">' + esc(primary.blurb) + '</p>' +
            '</div>' +
            '<div class="eq-price-card">' +
              '<div class="eq-price-label">' + (primary.from ? "From" : "Price") + '</div>' +
              '<div class="eq-price-num">' + esc(primary.price) + '</div>' +
              '<div class="eq-price-pp">per person</div>' +
              '<a href="' + esc(primary.url) + '" class="eq-price-cta" target="_blank" rel="noopener">Book now <span class="eq-arr" aria-hidden="true">→</span>' + NEWTAB + '</a>' +
              '<a href="https://everymandrivingexperiences.co.uk/collections/gift-vouchers" class="eq-price-secondary" target="_blank" rel="noopener">Send as a gift voucher' + NEWTAB + '</a>' +
            '</div>' +
          '</div>' +

          '<div class="eq-inc-sect">' +
            '<div class="eq-sect-label"><span class="bar" aria-hidden="true"></span>What\'s included</div>' +
            '<div class="eq-inc-grid">' +
              (primary.includes || []).map(function (item, i) {
                return '<div class="eq-inc-item"><span class="eq-inc-n" aria-hidden="true">0' + (i + 1) +
                       '</span><span class="eq-inc-t">' + esc(item) + '</span></div>';
              }).join("") +
            '</div>' +
          '</div>' +

          '<div class="eq-why">' +
            '<div class="eq-sect-label"><span class="bar" aria-hidden="true"></span>Why this match</div>' +
            '<div class="eq-why-grid" style="grid-template-columns: repeat(' + Math.min(Math.max(reasons.length, 1), 4) + ', 1fr)">' +
              reasons.map(function (rs) {
                return '<div class="eq-reason"><div class="rk">' + esc(rs.k) +
                       '</div><div class="rv">' + esc(rs.v) + '</div></div>';
              }).join("") +
            '</div>' +
          '</div>' +

          '<div class="eq-ctas">' +
            '<a href="' + esc(primary.url) + '" class="eq-btn eq-btn-primary" target="_blank" rel="noopener">Book now <span class="eq-arr" aria-hidden="true">→</span>' + NEWTAB + '</a>' +
            '<a href="https://everymandrivingexperiences.co.uk/collections/all" class="eq-btn eq-btn-ghost" target="_blank" rel="noopener">Browse all experiences' + NEWTAB + '</a>' +
            '<button class="eq-btn eq-btn-ghost eq-restart" type="button">Retake quiz</button>' +
          '</div>' +

          '<div class="eq-alt">' +
            '<div class="eq-alt-head">Also worth considering</div>' +
            '<div class="eq-alt-row">' +
              '<div class="eq-alt-thumb"><img src="' + esc(imgAlt) + '" alt="" aria-hidden="true" loading="lazy" decoding="async" /></div>' +
              '<div>' +
                '<div class="eq-alt-name">' + esc(alternate.name) + '</div>' +
                '<div class="eq-alt-tag">' + esc(alternate.tagline) + '</div>' +
              '</div>' +
              '<div style="text-align:right;flex-shrink:0">' +
                '<div class="eq-alt-price">' + esc(alternate.price) + '</div>' +
                '<a href="' + esc(alternate.url) + '" class="eq-btn eq-btn-ghost" target="_blank" rel="noopener">View <span class="eq-arr" aria-hidden="true">→</span>' + NEWTAB + '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div class="eq-trust-strip"><div class="eq-shell"><div class="eq-trust-inner">' +
          [
            [EMR_YEARS + " years", "Award-winning service"],
            ["★ 9-year", "TripAdvisor Travellers' Choice"],
            ["22+", "UK venues"],
            ["60-day", "Full refund policy"],
            ["eVoucher", "Delivered in 2 hours"]
          ].map(function (t) {
            return '<div class="eq-trust-item"><span class="tk">' + esc(t[1]) +
                   '</span><span class="tv">' + esc(t[0]) + '</span></div>';
          }).join("") +
        '</div></div></div>' +
      '</div>'
    );
    if (!section) { state.screen = "intro"; return renderIntro(); }
    mount.appendChild(section);
    bindImgFallback(mount);

    var restart = function () {
      state.answers = {};
      state.idx = 0;
      state.result = null;
      state.screen = "intro";
      state.booted = true;
      render();
      motionScroll();
    };
    var a = section.querySelector(".eq-retake");
    var b = section.querySelector(".eq-restart");
    if (a) a.addEventListener("click", restart);
    if (b) b.addEventListener("click", restart);

    announce("Your match: " + primary.name + ". " + (primary.from ? "From " : "") + primary.price + " per person.");
    if (state.booted) focusEl(section.querySelector("#" + uid + "-res"));
  }

  function destroy() {
    try { if (live && live.parentNode) live.parentNode.removeChild(live); } catch (e) {}
    if (mount) mount.innerHTML = "";
  }

  return { render: render, destroy: destroy };
}

/* ─── Boot: one controller per .emr-quiz, re-entry safe ─── */
function initRoot(el) {
  if (!el) return;
  var root = (el.classList && el.classList.contains("emr-quiz")) ? el
           : (el.querySelector ? el.querySelector(".emr-quiz") : null);
  if (!root || root.__emrController) return;     /* already initialised */
  var controller = createQuiz(root);
  if (controller) { root.__emrController = controller; controller.render(); }
}
function boot() {
  var roots = document.querySelectorAll(".emr-quiz");
  for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
}
/* expose so a second (accidental) evaluation of the asset can still bind
   any not-yet-initialised roots instead of throwing */
window.__emrQuizBoot = boot;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
/* Shopify theme editor: sections are injected / removed after load */
document.addEventListener("shopify:section:load", function (e) { initRoot(e.target); });
document.addEventListener("shopify:section:unload", function (e) {
  var root = e.target && e.target.querySelector ? e.target.querySelector(".emr-quiz") : null;
  if (root && root.__emrController) { root.__emrController.destroy(); root.__emrController = null; }
});
})();
